import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../icon/Icon';
import { makeNativeLink, makeNotNativeLink, makeNoFollowLink, makeDisabledLink, makeLinkIcon, makeAnchorLink } from './mixins';
var NativeLinkComponent = styled(NavLink)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeNativeLink(props);
});
var NotNativeLinkComponent = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeNotNativeLink(props);
});
var NoFollowLinkComponent = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeNoFollowLink(props);
});
var DisabledLinkComponent = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeDisabledLink(props);
});
var LinkIcon = styled(Icon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeLinkIcon(props);
});
var AnchorLinkComponent = styled.a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeAnchorLink(props);
});

var NativeLink = function NativeLink(props) {
  var href = props.href,
      icon = props.icon,
      children = props.children,
      _props$linkoptions = props.linkoptions,
      linkoptions = _props$linkoptions === void 0 ? {
    size: 'medium'
  } : _props$linkoptions;
  var reactRouterOptions = props.reactRouterOptions;

  if (!reactRouterOptions || reactRouterOptions && !('pathname' in reactRouterOptions)) {
    reactRouterOptions = Object.assign(Object.assign({}, reactRouterOptions), {
      pathname: href
    });
  }

  return React.createElement(NativeLinkComponent, Object.assign({}, props, linkoptions, {
    content: children,
    to: Object.assign({}, reactRouterOptions)
  }), icon && React.createElement(LinkIcon, Object.assign({}, icon, {
    linkoptions: linkoptions,
    content: children
  })), children);
};

var NotNativeLink = function NotNativeLink(props) {
  var icon = props.icon,
      children = props.children,
      _props$linkoptions2 = props.linkoptions,
      linkoptions = _props$linkoptions2 === void 0 ? {
    size: 'medium'
  } : _props$linkoptions2;
  return React.createElement(NotNativeLinkComponent, Object.assign({}, props, linkoptions, {
    content: children
  }), icon && React.createElement(LinkIcon, Object.assign({}, icon, {
    linkoptions: linkoptions,
    content: children
  })), children);
};

var NoFollowLink = function NoFollowLink(props) {
  var link = props.link,
      icon = props.icon,
      children = props.children,
      _props$linkoptions3 = props.linkoptions,
      linkoptions = _props$linkoptions3 === void 0 ? {
    size: 'medium'
  } : _props$linkoptions3;

  var redirect = function redirect() {
    window.location.href = link;
  };

  return React.createElement(NoFollowLinkComponent, Object.assign({}, props, linkoptions, {
    content: children,
    rel: "nofollow",
    "data-url": "".concat(link),
    onClick: function onClick() {
      return redirect();
    }
  }), icon && React.createElement(LinkIcon, Object.assign({}, icon, {
    linkoptions: linkoptions,
    content: children
  })), children);
};

var DisabledLink = function DisabledLink(props) {
  var icon = props.icon,
      children = props.children,
      _props$linkoptions4 = props.linkoptions,
      linkoptions = _props$linkoptions4 === void 0 ? {
    size: 'medium'
  } : _props$linkoptions4;
  return React.createElement(DisabledLinkComponent, Object.assign({}, props, linkoptions, {
    content: children
  }), icon && React.createElement(LinkIcon, Object.assign({}, icon, {
    linkoptions: linkoptions,
    content: children
  })), children);
};

var AnchorLink = function AnchorLink(props) {
  var icon = props.icon,
      children = props.children,
      _props$linkoptions5 = props.linkoptions,
      linkoptions = _props$linkoptions5 === void 0 ? {
    size: "medium"
  } : _props$linkoptions5,
      openContactAgentClick = props.openContactAgentClick;

  var scrollToSection = function scrollToSection(section) {
    return window.scrollTo({
      top: section,
      behavior: 'smooth'
    });
  };

  var getScrollToSectionId = function getScrollToSectionId(element) {
    return element.target.getAttribute('href');
  };

  var scroll = function scroll(ref) {
    ref.preventDefault();
    var sectionId = getScrollToSectionId(ref);

    if (sectionId) {
      var section = document.getElementById(sectionId.substring(1));

      if (!section) {
        return;
      }

      var sectionOffsetTop = section.offsetTop;
      scrollToSection(sectionOffsetTop);
    }
  };

  return React.createElement(AnchorLinkComponent, Object.assign({}, props, {
    onClick: function onClick(ref) {
      openContactAgentClick && openContactAgentClick();
      scroll(ref);
    },
    content: children
  }), icon && React.createElement(LinkIcon, Object.assign({}, icon, {
    linkoptions: linkoptions,
    content: children
  })), children);
};

export var Link = function Link(props) {
  var linkoptions = props.linkoptions,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$noFollow = props.noFollow,
      noFollow = _props$noFollow === void 0 ? false : _props$noFollow;
  if (disabled) return DisabledLink(props);
  if (noFollow) return NoFollowLink(props);
  if (linkoptions && linkoptions.native) return NativeLink(props);
  if (linkoptions && linkoptions.anchor) return AnchorLink(props);
  return NotNativeLink(props);
};